import {ModuleProto} from "../../module-proto";
import {ModuleType} from "../../types";
import slackSettings_disconnect from "../../../../app/integrations/settings/slack/actions/disconnect";
import slackSettings_connect from "../../../../app/integrations/settings/slack/actions/connect";
import {SettingsMenuTopCategory} from "../../settings-module";
import {SettingsParentSection} from "../../../../app/settings/const";

// const debug = "SlackModule"
const debug = false

export class SlackModule extends ModuleProto {

    public connectedChannels   : any
    public slackChannels       : any

    constructor() {
        super(ModuleType.SLACK, {});

        debug && console.log(debug, "constructor() moduleConfig=")

        this.name                    = "Slack"
        this.description             = "Connect GoodDay to your Slack chat channels to stay on top of all work activity, perfectly organized and connected."
        this.svgIcon                 = "isvg-slack"
        this.settingsMenuTopCategory = SettingsMenuTopCategory.INTEGRATIONS
        this.typeLabel               = "Integrations"
        this.connectedChannels       = []
        this.slackChannels           = []
        this.settingsUrl             = "settings/integrations/slack"
        this.parentSection          = SettingsParentSection.INTEGRATIONS


        debug && console.log(debug, "_isEnabled", this._isEnabled)
    }

    enable = async()=> {
        slackSettings_connect()
        gd.modules.saveConfig()
    }

     disable = async()=>{
        slackSettings_disconnect()
         gd.modules.saveConfig()
    }

    toJson() {
        debug && console.log(debug, "toJson() type=",this.type, "_isEnabled=", this._isEnabled)
        const result = super.toJson();
        debug && console.log(debug, "    newConfig=", result)

        return result
    }
}
